import { BaseApi } from './base.api'

export class StatisticApi extends BaseApi {
	constructor() {
		super('api/admin/statistic')
	}

	async getPercentWordDontHaveDefinitionWithInterval(data) {
		let params = new URLSearchParams(data).toString()
		const rs = await this.get(`/percent-dont-have-definition?${params}`)
		return rs
	}
}
